import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { InsignDistributionJob } from '@app/shared/models/distribution-doc-models';
import { UntypedFormControl, Validators } from '@angular/forms';
import { EmailChipsComponent } from '@app/shared/components/email-chips/email-chips.component';

@Component({
    templateUrl: './insign-email-distribution-dialog.component.html',
    styleUrls: ['./insign-email-distribution-dialog.component.scss']
})
export class InSignEmailDistributionDialogComponent extends BaseComponent
                                                    implements OnInit {

    @ViewChild('to_chips', { static: true })
    private to_chips: EmailChipsComponent;

    public to_addressInvalid = false;
    public insign_email_subject: UntypedFormControl;

    private hasBeenModified: boolean;

    get emailBodyHasError(): boolean {
        return this.isCaseDistributionJob && this.hasBeenModified && !this.data.insign_email_body_before_link && !this.data.insign_email_body_after_link;
    }

    get onlyContainsValidEmailAddresses(): boolean {
        return !this.to_addressInvalid && !!this.data.insign_email_to;
    }

    get saveBtnEnabled() {
        return !this.isCaseDistributionJob ||
                   (this.onlyContainsValidEmailAddresses &&
                    this.insign_email_subject.valid &&
                   (this.data.insign_email_body_before_link || this.data.insign_email_body_after_link));
    }

    get isCaseDistributionJob(): boolean {
        return !!this.data && !this.data.workflow_id;
    }

    constructor(public dialogRef: MatDialogRef<InSignEmailDistributionDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: InsignDistributionJob) {
        super();
        this._idPrefix = 'insign-email-distribution-dialog.';

        this.insign_email_subject = new UntypedFormControl(
            {
                value: this.data.insign_email_subject,
                disabled: this.disabled
            },
            {
                updateOn: 'blur',
                validators: this.isCaseDistributionJob ? [Validators.required] : [],
            });
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public updateTextAreaValidation(): void {
        this.hasBeenModified = true;
    }

    public accept(): void {
        if (this.saveBtnEnabled) {
            this.data.insign_email_subject = this.insign_email_subject.value;
            this.dialogRef.close(this.data);
        }
    }

    public close(): void {
        this.dialogRef.close();
    }
}
